import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Transition, TransitionGroup } from 'react-transition-group'
import AnimatedCircle from '../ui-elements/animated-circle'
import {
  SliderWrapper,
  SliderItem,
  Section,
  Pagination,
  PaginationItem,
} from './index.styled'

const Slider = ({
  id,
  images,
  pagination = true,
  delay = 5000,
  paginationLeft = false,
}) => {
  const [currentItem, setCurrentItem] = React.useState(0)

  React.useEffect(() => {
    let internalCurrentItem = currentItem

    let interval = setTimeout(() => {
      internalCurrentItem = images?.[internalCurrentItem + 1]
        ? internalCurrentItem + 1
        : 0
      setCurrentItem(internalCurrentItem)
    }, delay)

    return () => clearInterval(interval)
  }, [currentItem])

  return (
    <Section id={id}>
      <SliderWrapper>
        <TransitionGroup component={null}>
          <Transition
            key={`slider-transition-item-${currentItem}`}
            timeout={{ enter: 2000, exit: 2000 }}
          >
            {(status) => (
              <>
                <SliderItem
                  key={`slider-${currentItem}`}
                  className={`${status}`}
                >
                  <GatsbyImage
                    image={getImage(images?.[currentItem]?.file)}
                    key={`image-list-${currentItem}`}
                    style={{ height: '100%' }}
                    alt=""
                  />
                </SliderItem>
              </>
            )}
          </Transition>
        </TransitionGroup>
        {images?.length > 1 && pagination && (
          <>
            <Pagination className={paginationLeft && 'left'}>
              {images?.map((item, index) => (
                <PaginationItem
                  key={`slider-pagination-item-${index}`}
                  onClick={() => setCurrentItem(index)}
                  $active={currentItem === index}
                >
                  <AnimatedCircle start={currentItem === index} />
                </PaginationItem>
              ))}
            </Pagination>
          </>
        )}
      </SliderWrapper>
    </Section>
  )
}

export default Slider
